

export default class Program {
  constructor(
    categories = [],
    equipment = [],
    id = null,
    image = null,
    intensity_level = null,
    fitnessgoals = [],
    musclegroup = [],
    name = '',
    overview = '',
    published = false,
    sets = [],
    tags = [],
    user = null,
    video = null,
    program_type = null,
    premium_required = false,
    copy = false,
  ) {
    this.categories = categories;
    this.equipment = equipment;
    this.id = id;
    this.image = image;
    this.intensity_level = intensity_level;
    this.fitnessgoals = fitnessgoals;
    this.musclegroup = musclegroup;
    this.name = name;
    this.overview = overview;
    this.published = published;
    this.sets = sets;
    this.tags = tags;
    // this.user = user;
    this.video = video;
    this.program_type = program_type;
    this.premium_required = premium_required;
    this.copy = copy;
  }
}
